import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { IServiceOrganizationSettingFormSectionProps } from '../ServiceOrganizationSetting';
import { ServiceType } from '../../../../../../common/enums/serviceType';
import { getAnalystAllowedByServiceCode } from '../../../../../../common/utils/getAnalystAllowedByServiceCode';
import { translateKey } from '../../../../../translate';
import { OrganizationSelection } from '../../../../elements/OrganizationSelection';
import { ServiceOrganizationSettingFormMode } from '../ServiceOrganizationSetting';

export function AnalystOrganizationFormSection(props: IServiceOrganizationSettingFormSectionProps) {
    if (
        props.service.serviceType !== ServiceType.examination ||
        !getAnalystAllowedByServiceCode(props.service.code) ||
        !props.hasBiometricians
    ) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceOrganizationSetting.ksyosHolterAnalystOrganization')}>
            <FormGroup
                hasErrors={props.errors.has('ksyosHolterAnalystOrganizationId')}
                label={translateKey('serviceOrganizationSetting.holterAnalystOrganization')}
            >
                {props.mode === ServiceOrganizationSettingFormMode.read ? (
                    <FormParagraph>{props.ksyosHolterAnalystOrganization.name || '-'}</FormParagraph>
                ) : (
                    <OrganizationSelection
                        error={props.errors.get('ksyosHolterAnalystOrganizationId')}
                        hasActiveTcohAnalyst={true}
                        isClearable={true}
                        onChange={async (organizationId) =>
                            props.handleChange('ksyosHolterAnalystOrganizationId', organizationId)
                        }
                        onDoValidate={async () => props.validateOne('ksyosHolterAnalystOrganizationId')}
                        placeholder={translateKey('organization.select')}
                        showCity={true}
                        value={props.ksyosHolterAnalystOrganizationId!}
                    />
                )}
            </FormGroup>
        </FormSection>
    );
}
